import { combineReducers, configureStore } from "@reduxjs/toolkit";
import thunkMiddleware from 'redux-thunk';
import { customerContactApi } from "../Service/customerContact";
import { api } from "../Service/customers";
import customer from "./reducers/digitalmarketing/customer";
import dashboard from "./reducers/digitalmarketing/dashboard";
import header from "./reducers/digitalmarketing/header";
import branches from "./reducers/digitalmarketing/branches";
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import auth from "./reducers/auth";
import branchList from "./reducers/digitalmarketing/branchList";



const Store = configureStore({
  reducer: combineReducers({
    auth: persistReducer(
      {
        key: 'account',
        storage,
        keyPrefix: 'mimokonnect-'
      },
      auth,
    ),
    header: header,
    customer: customer,
    dashboard: dashboard,
    branches: branches,
    branchlist:branchList,
    [api.reducerPath]: api.reducer,
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(api.middleware).concat(thunkMiddleware),
});
export const persister = persistStore(Store);

export default Store;
